/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxmUserauthV1TenantQueryServiceTenantGetResponse, IxmUserauthV1TenantQueryServiceTenantGetTenantGetRequest } from '@interxfi/types';

export const IXM_USERAUTH_V1_TENANT_QUERY_SERVICE_TENANT_GET_AUDIENCE = ['platform', 'organization'];

export async function ixmUserauthV1TenantQueryServiceTenantGet(baseUrl: string | undefined, request?: IxmUserauthV1TenantQueryServiceTenantGetTenantGetRequest, requestInit?: RequestInit): Promise<IxmUserauthV1TenantQueryServiceTenantGetResponse | undefined> { return makeRequest<IxmUserauthV1TenantQueryServiceTenantGetResponse, IxmUserauthV1TenantQueryServiceTenantGetTenantGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/portal/userauth/v1/tenant/q/:tenantId', request, requestInit)); }

